import { Gift } from '@patrianna-icons/material-icons'
import cx from 'classnames'

import type { SupportedCurrencies } from 'types/currencies'

import classes from '../styles.module.scss'

type Props = {
  activeCurrency: SupportedCurrencies
  gamePrizeAmount?: string
}

export default function GamePrize({ activeCurrency, gamePrizeAmount }: Props) {
  return (
    <div className={classes.infoRowItem}>
      <Gift className={cx(classes.icon, classes[`icon-${activeCurrency}`])} />
      <span>
        <span className={classes.currency}>{activeCurrency}</span>
        {gamePrizeAmount}
      </span>
    </div>
  )
}
